<template>
  <ApolloMutation
  :mutation="(gql) => gql`
    mutation CreateStripeAccount {
      createStripeAccountUser(input: {}) {
        user {
          id
          stripeAccount {
            id
            chargesEnabled
            accountLink
          }
        }
      }
    }
  `"
  @done="(result) => {handleStripeLinkGeneration(result.data.createStripeAccountUser.user.stripeAccount)}"
>
  <template v-slot="{ mutate, loading }">
    <v-btn  class="pa-8" @click="mutate()" :disabled="loading || forwarding" :loading="loading || forwarding" color="primary">{{$t('becomeACreator.houseKeeping.connectStripeAccount')}}</v-btn>
  </template>
</ApolloMutation>
</template>
<script>
export default {
  props: {
    forwarding: Boolean,
  },
  methods: {
    handleStripeLinkGeneration(stripeAccount) {
      this.$emit('forwarding', true);
      window.location.href = stripeAccount.accountLink;
    },
  },
}
</script>